import { useScroll } from "framer-motion";
import React, { useEffect } from "react";

const useDisplayStickyButton = () => {
  const [showTopButton, setTopButton] = React.useState(false);
  const [isSticky, setIsSticky] = React.useState(false);
  const { scrollY } = useScroll();

  useEffect(() => {
    const unsubscribe = scrollY.onChange((latestScrollY) => {
      setTopButton(latestScrollY > 250);
      setIsSticky(latestScrollY > 90);
    });

    return () => {
      unsubscribe();
    };
  }, [scrollY]);
  return { showTopButton, isSticky };
};

export default useDisplayStickyButton;
